import { TFunction } from 'i18next';
import { IntegrationTypeHandler } from './integrationTypeHandler';

//Mirrors IntegrationType.IntegrationChecks in the API: what an integration measures, independent of the app
//that measures it. Values 1..7 equal the type id of the first implementation; the dormant SecureScoreCloud (4)
//is left out like MS_SecureScoresCloud in IntegrationTypes.
export enum IntegrationChecks {
  NotSet = 0,
  MFA = 1,
  SecureScoreM365 = 2,
  SecureScoreIdentity = 3,
  SecureScoreDevice = 5,
  SecureScoreDeviceExposure = 6,
  TlsRating = 7,
  //the Entra baseline checks take 8..12 (API Docs/MS_EntraBaseline.md)
  AdminMfaConditionalAccess = 8,
  AdminPortalRestriction = 9,
  AppRegistrationRestricted = 10,
  GuestInviteRestriction = 11,
  GuestAccessRestriction = 12,
  //the Azure checks (API Docs/MS_Azure.md)
  DatabasesNotPublic = 17,
  KeyVaultsLockedDown = 18,
  LogsKept = 19,
  SecretsExpiry = 20,
}

export class IntegrationCheckHandler {
  integrationCheckId: IntegrationChecks;

  name: string;

  description: string;

  integrationTypes: IntegrationTypeHandler[];

  constructor() {
    this.integrationCheckId = IntegrationChecks.NotSet;
    this.name = '';
    this.description = '';
    this.integrationTypes = [];
  }
}

export function getIntegrationChecks(t: TFunction<string[]>): IntegrationCheckHandler[] {
  const integrationChecks: IntegrationCheckHandler[] = [];

  const ich_MFA = new IntegrationCheckHandler();
  ich_MFA.integrationCheckId = IntegrationChecks.MFA;
  ich_MFA.name = t('integrations:Checks.MFA.Name');
  ich_MFA.description = t('integrations:Checks.MFA.Description');
  integrationChecks.push(ich_MFA);

  const ich_SecureScoreM365 = new IntegrationCheckHandler();
  ich_SecureScoreM365.integrationCheckId = IntegrationChecks.SecureScoreM365;
  ich_SecureScoreM365.name = t('integrations:Checks.SecureScoreM365.Name');
  ich_SecureScoreM365.description = t('integrations:Checks.SecureScoreM365.Description');
  integrationChecks.push(ich_SecureScoreM365);

  const ich_SecureScoreIdentity = new IntegrationCheckHandler();
  ich_SecureScoreIdentity.integrationCheckId = IntegrationChecks.SecureScoreIdentity;
  ich_SecureScoreIdentity.name = t('integrations:Checks.SecureScoreIdentity.Name');
  ich_SecureScoreIdentity.description = t('integrations:Checks.SecureScoreIdentity.Description');
  integrationChecks.push(ich_SecureScoreIdentity);

  const ich_SecureScoreDevice = new IntegrationCheckHandler();
  ich_SecureScoreDevice.integrationCheckId = IntegrationChecks.SecureScoreDevice;
  ich_SecureScoreDevice.name = t('integrations:Checks.SecureScoreDevice.Name');
  ich_SecureScoreDevice.description = t('integrations:Checks.SecureScoreDevice.Description');
  integrationChecks.push(ich_SecureScoreDevice);

  const ich_SecureScoreDeviceExposure = new IntegrationCheckHandler();
  ich_SecureScoreDeviceExposure.integrationCheckId = IntegrationChecks.SecureScoreDeviceExposure;
  ich_SecureScoreDeviceExposure.name = t('integrations:Checks.SecureScoreDeviceExposure.Name');
  ich_SecureScoreDeviceExposure.description = t('integrations:Checks.SecureScoreDeviceExposure.Description');
  integrationChecks.push(ich_SecureScoreDeviceExposure);

  const ich_TlsRating = new IntegrationCheckHandler();
  ich_TlsRating.integrationCheckId = IntegrationChecks.TlsRating;
  ich_TlsRating.name = t('integrations:Checks.TlsRating.Name');
  ich_TlsRating.description = t('integrations:Checks.TlsRating.Description');
  integrationChecks.push(ich_TlsRating);

  const ich_AdminMfaConditionalAccess = new IntegrationCheckHandler();
  ich_AdminMfaConditionalAccess.integrationCheckId = IntegrationChecks.AdminMfaConditionalAccess;
  ich_AdminMfaConditionalAccess.name = t('integrations:Checks.AdminMfaConditionalAccess.Name');
  ich_AdminMfaConditionalAccess.description = t('integrations:Checks.AdminMfaConditionalAccess.Description');
  integrationChecks.push(ich_AdminMfaConditionalAccess);

  const ich_AdminPortalRestriction = new IntegrationCheckHandler();
  ich_AdminPortalRestriction.integrationCheckId = IntegrationChecks.AdminPortalRestriction;
  ich_AdminPortalRestriction.name = t('integrations:Checks.AdminPortalRestriction.Name');
  ich_AdminPortalRestriction.description = t('integrations:Checks.AdminPortalRestriction.Description');
  integrationChecks.push(ich_AdminPortalRestriction);

  const ich_AppRegistrationRestricted = new IntegrationCheckHandler();
  ich_AppRegistrationRestricted.integrationCheckId = IntegrationChecks.AppRegistrationRestricted;
  ich_AppRegistrationRestricted.name = t('integrations:Checks.AppRegistrationRestricted.Name');
  ich_AppRegistrationRestricted.description = t('integrations:Checks.AppRegistrationRestricted.Description');
  integrationChecks.push(ich_AppRegistrationRestricted);

  const ich_GuestInviteRestriction = new IntegrationCheckHandler();
  ich_GuestInviteRestriction.integrationCheckId = IntegrationChecks.GuestInviteRestriction;
  ich_GuestInviteRestriction.name = t('integrations:Checks.GuestInviteRestriction.Name');
  ich_GuestInviteRestriction.description = t('integrations:Checks.GuestInviteRestriction.Description');
  integrationChecks.push(ich_GuestInviteRestriction);
  const ich_GuestAccessRestriction = new IntegrationCheckHandler();
  ich_GuestAccessRestriction.integrationCheckId = IntegrationChecks.GuestAccessRestriction;
  ich_GuestAccessRestriction.name = t('integrations:Checks.GuestAccessRestriction.Name');
  ich_GuestAccessRestriction.description = t('integrations:Checks.GuestAccessRestriction.Description');
  integrationChecks.push(ich_GuestAccessRestriction);
  const ich_DatabasesNotPublic = new IntegrationCheckHandler();
  ich_DatabasesNotPublic.integrationCheckId = IntegrationChecks.DatabasesNotPublic;
  ich_DatabasesNotPublic.name = t('integrations:Checks.DatabasesNotPublic.Name');
  ich_DatabasesNotPublic.description = t('integrations:Checks.DatabasesNotPublic.Description');
  integrationChecks.push(ich_DatabasesNotPublic);

  const ich_KeyVaultsLockedDown = new IntegrationCheckHandler();
  ich_KeyVaultsLockedDown.integrationCheckId = IntegrationChecks.KeyVaultsLockedDown;
  ich_KeyVaultsLockedDown.name = t('integrations:Checks.KeyVaultsLockedDown.Name');
  ich_KeyVaultsLockedDown.description = t('integrations:Checks.KeyVaultsLockedDown.Description');
  integrationChecks.push(ich_KeyVaultsLockedDown);

  const ich_LogsKept = new IntegrationCheckHandler();
  ich_LogsKept.integrationCheckId = IntegrationChecks.LogsKept;
  ich_LogsKept.name = t('integrations:Checks.LogsKept.Name');
  ich_LogsKept.description = t('integrations:Checks.LogsKept.Description');
  integrationChecks.push(ich_LogsKept);

  const ich_SecretsExpiry = new IntegrationCheckHandler();
  ich_SecretsExpiry.integrationCheckId = IntegrationChecks.SecretsExpiry;
  ich_SecretsExpiry.name = t('integrations:Checks.SecretsExpiry.Name');
  ich_SecretsExpiry.description = t('integrations:Checks.SecretsExpiry.Description');
  integrationChecks.push(ich_SecretsExpiry);

  return integrationChecks;
}

//Buckets the catalogue types under their check. The check id comes from the API type row, like the group id,
//so a type the API has not classified (NotSet) lands in no check.
export function assignIntegrationTypesToChecks(
  checks: IntegrationCheckHandler[],
  integrationTypes: IntegrationTypeHandler[],
): IntegrationCheckHandler[] {
  for (const check of checks) {
    check.integrationTypes = integrationTypes.filter((it) => it.getIntegrationCheckId() === check.integrationCheckId);
  }

  return checks;
}

//The fallback covers a check id this build does not know yet, or a type row the API has not classified.
export function getIntegrationCheckName(
  checks: IntegrationCheckHandler[],
  integrationCheckId: IntegrationChecks,
  fallback: string,
): string {
  return checks.find((c) => c.integrationCheckId === integrationCheckId)?.name ?? fallback;
}
